import { toDate } from './timestamps';

export function formatDate(
  timestamp: unknown,
  format: 'date' | 'time' | 'datetime' = 'date'
): string {
  const date = toDate(timestamp);
  if (!date) return '—';

  const options: Intl.DateTimeFormatOptions = {};

  if (format === 'date' || format === 'datetime') {
    options.year = 'numeric';
    options.month = 'short';
    options.day = 'numeric';
  }

  if (format === 'time' || format === 'datetime') {
    options.hour = 'numeric';
    options.minute = '2-digit';
    options.hour12 = true;
  }

  return date.toLocaleDateString('en-US', options);
}

export function formatRelativeDate(timestamp: unknown): string {
  const date = toDate(timestamp);
  if (!date) return '—';

  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (seconds < 60) return 'just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;

  return formatDate(date, 'date');
}
